import React, { useState, useRef, useEffect } from "react";
import QRCode from 'react-qr-code';
import { useCompactPortrait } from 'components/navigation/NavigationContext';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const themeOptions = [
  { name: "light", label: "Light", icon: <i className="bi bi-brightness-high"></i> },
  { name: "dark", label: "Dark", icon: <i className="bi bi-moon"></i> },
  { name: "system", label: "System", icon: <i className="bi bi-laptop"></i> },
];

export default function ThemeSideMenu({ theme, setTheme }) {
  const [open, setOpen] = useState(false);
  const compact = useCompactPortrait();
  const ref = useRef(null);
  useEffect(() => setOpen(false), [compact]);

  // Close when clicking outside or pressing Escape
  useEffect(() => {
    if (!open) return;

    function onPointerDown(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    function onKeyDown(e) {
      if (e.key === "Escape") setOpen(false);
    }

    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  if (compact) return null;

  return (
    <div ref={ref} className={`theme-side-menu${open ? " open" : ""}`}>
      {/* <OverlayTrigger
        placement="left"
        overlay={<Tooltip id="theme-side-tooltip">Theme Options</Tooltip>}
      > */}
      <button
        className="theme-side-toggle"
        onClick={() => setOpen((v) => !v)}
      // aria-label="Toggle theme menu"
      // title="Toggle theme menu"
      >
        {/* arrow icon */}
        <span className="bi bi-mask" aria-hidden="true"></span>
      </button>
      {/* </OverlayTrigger> */}

      {open && (
        <div className="theme-options" role="menu" aria-hidden={!open}>
          <div className="theme-options-row" role="group" aria-label="Theme options">
            {themeOptions.map((opt) => (
              <button
                key={opt.name}
                className={`theme-dot${theme === opt.name ? " active" : ""}`}
                onClick={() => {
                  setTheme(opt.name);
                  setOpen(false); // close menu when an item is clicked
                }}
                aria-label={opt.label}
                title={opt.label}
                role="menuitem"
              >
                {opt.icon}
              </button>
            ))}
          </div>

          <div className="theme-options-qr">
            <QRCode
              title="Share this page via QR Code"
              value={window.location.href}
              size={120}
              bgColor="#181b23"
              fgColor="#fff"
            />
          </div>
          <div className="theme-options-qr">
            <span style={{ color: "#fff" }}>Share this page</span>
          </div>
        </div>
      )}
    </div>
  );
}